import axios from 'axios';
import { setBlockTracking } from 'vue';
import addresstypes from './addresstypes';
// initial state
// shape: [{ id, quantity }]
const state = () => ({
    list : [
    ],
    loaded : false,
    addNew : false,
    workingOn: [],
})

  // getters
  const getters = {
    get: (state) => (type) => {
        return state.list.filter(item => item.type == type);
    }
  }

  // actions
  const actions = {
  }

  // mutations
  const mutations = {
      clearBlocks(state){
          state.list = [];
      },
      addBlock(state, blocks){
          state.list.push(blocks.data);
      },
      setBlock(state, data){
        state.list[data.index].data = data.data;
      },
      init(state, data){
          state.list = data;
      },
  }

  export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
    modules: {
    }
  }
